// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import ProjectP5Trajet from './pages/ProjectP5Trajet';
import ProjectP5Drawings from './pages/ProjectP5Drawings';
import Project3DText from './pages/Project3DText';
import ProjectThreeHaunted from './pages/ProjectThreeHaunted';
import ProjectThreeGalaxy from './pages/ProjectThreeGalaxy';
import ProjectNewJeans from './pages/ProjectNewJeans';
import ProjectFigma from './pages/ProjectFigma';
import ProjectSeekachu from './pages/ProjectSeekachu';
import ProjectEcommerceMobilier from './pages/ProjectEcommerceMobilier';
import ProjectCovoiturage from './pages/ProjectCovoiturage';
import ProjectUniverse from './pages/ProjectUniverse';
import ProjectFlowly from './pages/ProjectFlowly';
import ProjectIllustrations from './pages/ProjectIllustrations';

import './styles/global.css';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Navbar /> {/* La barre de navigation reste visible partout */}
      <Routes>
        {/* 🏠 L'ACCUEIL : S'affiche quand on arrive sur le site */}
        <Route path="/" element={<Home />} />

        {/* 📂 LES PROJETS : S'affichent quand on clique sur les liens */}
        <Route path="/p5js-trajet" element={<ProjectP5Trajet />} />
        <Route path="/p5js-drawings" element={<ProjectP5Drawings />} />
        <Route path="/threejs-3dtext" element={<Project3DText />} />
        <Route path="/threejs-hauntedhouse" element={<ProjectThreeHaunted />} />
        <Route path="/threejs-galaxy" element={<ProjectThreeGalaxy />} />
        <Route path="/newjeansNeverDie" element={<ProjectNewJeans />} />
        <Route path="/projet/seekachu" element={<ProjectSeekachu />} />
        <Route path="/projet/ecommerce-mobilier" element={<ProjectEcommerceMobilier />} />
        <Route path="/projet/covoiturage" element={<ProjectCovoiturage />} />
        <Route path="/projet/universe" element={<ProjectUniverse />} />
        <Route path="/projet/flowly" element={<ProjectFlowly />} />
        <Route path="/projet/illustrations" element={<ProjectIllustrations />} />
        <Route path="/projet/:id" element={<ProjectFigma />} />

        {/* 🛡️ SÉCURITÉ : Redirige vers l'accueil si l'URL est introuvable */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      <Analytics /> 
      <SpeedInsights />
    </BrowserRouter>
  );
}

export default App;